'use client'

import { useEffect, useMemo } from 'react'
import { usePathname } from 'next/navigation'
import { track } from '@/services/api/tracking/Pixel.service'

function mapPathToRouteString(pathname: string): string {
  const path = pathname === '/' ? '/' : pathname.replace(/\/+$/, '')

  if (path === '/') return 'homeNew'
  if (path.startsWith('/videos')) return 'videoNew'

  return 'pageNew'
}

export default function TrackingPixel() {
  const pathname = usePathname()

  const routeString = useMemo(
    () => mapPathToRouteString(pathname || '/'),
    [pathname],
  )

  useEffect(() => {
    track(routeString).then(() => {})
  }, [routeString])

  return null
}
